import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { chatlaunch } from "@nrg-storybook/reliant-component-library/lib/scripts/chatlaunch";
import { readCookie } from "@nrg-storybook/reliant-component-library/lib/scripts/index";

const NiceChat = () => {
  const { i18n, t } = useTranslation();
  const chatChannel = process.env.CHATCHANNEL;
  const lang = i18n.language || readCookie("language");
  const chatLanguage = lang?.toLowerCase() === "es" ? "Spanish" : "English";
  const current_date = new Date();
  const hour = Number(
    current_date.toLocaleTimeString("en-US", {
      timeZone: "America/Chicago",
      hour12: false,
      hour: "numeric"
    })
  );
  const day = current_date.getDay();

  useEffect(() => {
    if (typeof window["cxone"] === "undefined") {
      if (day >= 1 && day <= 5 && hour >= 8 && hour < 18) {
        // MON - FRI 8AM - 6PM Central
        chatlaunch({
          channel: chatChannel,
          language: chatLanguage,
          applaunchsource: "web",
          showTermsOfUseLabel: t("productChart:chat.show_terms_of_use_label"),
          showTermsOfUseLink: t("productChart:chat.show_terms_of_use_link", {
            baseUrl: process.env.CIRRO_ENERGY_URL
          })
        });
      }
    } else {
      window.location.reload();
    }
  }, [chatLanguage]);
  return <></>;
};

export default NiceChat;
